export { default as ReactIcon } from './ReactIcon';
